<template>
    <main>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                      <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Create Applicaton Package</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericNew v-if="generic" ref="loadGeneric" :urls="urls"></GenericNew>
        <CustomNew v-else></CustomNew>  

    </main> 
</template>

<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/WorkPackages/MenuList.vue";
import lang from "@/views/modules/WorkPackages/language/en";
import GenericNew from "@/components/layout/shared/generic/NewView.vue";
import CustomNew from "@/views/modules/WorkPackages/NewView.vue";

export default {
name: "new-application-package",
components: {
        breadcrumbs, 
        GenericNew,
        CustomNew,
    },
    data(){
        return {
            generic: false,
            metaList:[
                
                {
                    type:'text',
                    name:'name',
                    label: lang.LBL_TAXTYPE_NAME,
                    required: true
                },
                {
                    type:'text',
                    name:'tax',
                    label: lang.LBL_TAX_RATE,
                    required: true
                },
                {
                    type:'selectbox',
                    name:'status',
                    label: lang.LBL_STATUS,
                    dom_access:true,
                    dom_key:'status_dom',
                    required: true
                },                
               {
                    type:'textarea',
                    name:'description',
                    label: lang.LBL_DESCRIPTION,
                    required: false
                },
            ],
            urls:'api/modules/opportunitys',
            
            routePath:{
                path:'opportunitys',
                detail:false
            }
            
        }
    },
    mounted() {
        this.childMethod()
    },
    methods:{
        childMethod(){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.routePath);
            }
        }
    },
}
</script>